/**
 * Builds the download filename for a PDF export.
 * Encodes form number, version, and last-modified timestamp so exports
 * are recognizable in a Downloads folder and deterministic for the same
 * form version (same browser/timezone).
 *
 * Consumers: FormExportModal (handleFinalExport)
 */
import type { Timestamp } from 'firebase/firestore';

export const buildPdfFilename = (
  formNumber: string | undefined,
  formVersionNumber: number | undefined,
  lastModified: Timestamp | undefined,
): string => {
  const slug = (formNumber ?? '').replace(/[^a-z0-9]+/gi, '-').replace(/^-+|-+$/g, '').toLowerCase();
  const base = slug ? `form-${slug}` : 'document';

  const version = formVersionNumber ? `-v${formVersionNumber}` : '';

  const date = lastModified != null ? lastModified.toDate() : new Date();
  const datePart = [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
  const timePart = [
    String(date.getHours()).padStart(2, '0'),
    String(date.getMinutes()).padStart(2, '0'),
    String(date.getSeconds()).padStart(2, '0'),
  ].join('-');

  return `${base}${version}_${datePart}_${timePart}.pdf`;
};
